<template>
    <b-modal id="qnaPasswordCheckModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>비밀번호</th>
                                <td class="ac"><input type="text" class="form_control" v-model="checkInfo.password"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_password_check()" class="btn btn_md btn_brown">확인</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>

    import axios from 'axios'

    export default {
        name: 'qnaPasswordCheckModal',
        props: {
            title: String,
            qna_seq : String
        },
        methods: {
            fn_password_check(){

                this.checkInfo.qna_seq = this.qna_seq;
                
                console.log("@@@@ checkInfo : %o",this.checkInfo);

                axios
                    .post("/api/user/board/chkQnaPassword", this.checkInfo)
                    .then((res) => {

                        this.checkResult = res.data.checkResult;

                        this.fn_click_apply();

                    })
                    .catch((err) => console.log(err));
            },
            fn_click_apply(){
                this.$emit('callback', this.checkResult);
            }          
        },
        data () {
            return {
                checkInfo : {
                    qna_seq : '',
                    password : ''
                },
                checkResult : false
            }
        }
    }
</script>

<style>

</style>